$(document).ready(function () {
  $("#MainContent > div > section > div > div").css("padding", 0);
  $(".header_main").addClass("landing_header_transparent");
  $(".section-header").css("position", "fixed");
  $(".main_menu_logo").css("background-color", "transparent");
  $(".header_main").removeClass("header_normal");
  $(".cls-1").css("fill", "none");
  $(".background-video-wrapper").parent().removeClass("p-2");
  $(".background-video-wrapper").parent().removeClass("lg:p-4");
  $(".cls-1").css("stroke", "white");
  $(".cls-2").css("stroke", "white");
  $(".logo-svg").css("fill", "white");
  $(".main_menu").css("color", "white");
  $(".customCartCounter").css("color", "white");
  $(".currency_switcher").css("color", "white");
  $("#shopify-section-header").mouseenter(function () {
    $(".header_main").removeClass("header_transparent");
    $(".header_main").removeClass("landing_header_transparent");
    $(".header_main").addClass("header_normal");
    $(".section-header").css("position", "fixed");
    $(".cls-1").css("stroke", "black");
    $(".cls-2").css("stroke", "black");
    $(".logo-svg").css("fill", "black");
    $(".customCartCounter").css("color", "black");
    $(".currency_switcher").css("color", "black");
    $(".main_menu ").css("color", "black");
  });

  // Mouse out of the header
  $("#shopify-section-header").mouseleave(function () {
    $(".header_main").addClass("header_transparent");
    $(".header_main").removeClass("header_normal");
    $(".section-header").css("position", "fixed");
    $(".cls-1").css("stroke", "white");
    $(".cls-2").css("stroke", "white");
    $(".logo-svg").css("fill", "white");
    $(".customCartCounter").css("color", "white");
    $(".main_menu").css("color", "white");
    $(".currency_switcher").css("color", "white");
  });
  // On scrolling
  window.addEventListener('scroll', () => {
    $(".header_main").removeClass("header_transparent");
    $(".header_main").removeClass("landing_header_transparent");
    $(".header_main").addClass("header_normal");
    $(".section-header").css("position", "fixed");
    $(".cls-1").css("stroke", "black");
    $(".cls-2").css("stroke", "black");
    $(".logo-svg").css("fill", "black");
    $(".customCartCounter").css("color", "black");
    $(".currency_switcher").css("color", "black");
    $(".main_menu ").css("color", "black");
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      $(".child_menu_burger").on("click", function () {
        $(".header_main").removeClass("header_transparent");
        $(".header_main").removeClass("landing_header_transparent");
        $(".header_main").addClass("header_normal");
        $(".section-header").css("position", "fixed");
        $(".cls-1").css("stroke", "black");
        $(".cls-2").css("stroke", "black");
        $(".logo-svg").css("fill", "black");
        $(".customCartCounter").css("color", "black");
        $(".currency_switcher").css("color", "black");
        $(".main_menu ").css("color", "black");
      });
      $(".child_menu_burger_close").on("click", function () {
        if ($(window).scrollTop() < 50) {
          $(".header_main").addClass("header_transparent");
          $(".header_main").removeClass("header_normal");
          $(".section-header").css("position", "fixed");
          $(".main_menu_logo").css("background-color", "transparent");
          $(".cls-1").css("stroke", "white");
          $(".cls-2").css("stroke", "white");
          $(".logo-svg").css("fill", "white");
          $(".customCartCounter").css("color", "white");
          $(".main_menu").css("color", "black");
          $(".currency_switcher").css("color", "black");
        }
      });
      if ($(window).scrollTop() < 50) {
        $(".header_main").addClass("header_transparent");
        $(".header_main").removeClass("header_normal");
        $(".section-header").css("position", "fixed");
        $(".main_menu_logo").css("background-color", "transparent");
        $(".cls-1").css("stroke", "white");
        $(".cls-2").css("stroke", "white");
        $(".logo-svg").css("fill", "white");
        $(".customCartCounter").css("color", "white");
        $(".main_menu").css("color", "black");
        $(".currency_switcher").css("color", "black");
      }
    } else {
      if ($(window).scrollTop() < 300) {
        $(".header_main").addClass("header_transparent");
        $(".header_main").removeClass("header_normal");
        $(".section-header").css("position", "fixed");
        $(".main_menu_logo").css("background-color", "transparent");
        $(".cls-1").css("stroke", "white");
        $(".cls-2").css("stroke", "white");
        $(".logo-svg").css("fill", "white");
        $(".customCartCounter").css("color", "white");
        $(".main_menu").css("color", "white");
        $(".currency_switcher").css("color", "white");
        $("#shopify-section-header").mouseenter(function () {
          $(".header_main").removeClass("header_transparent");
          $(".header_main").removeClass("landing_header_transparent");
          $(".header_main").addClass("header_normal");
          $(".section-header").css("position", "fixed");
          $(".cls-1").css("stroke", "black");
          $(".cls-2").css("stroke", "black");
          $(".logo-svg").css("fill", "black");
          $(".customCartCounter").css("color", "black");
          $(".currency_switcher").css("color", "black");
          $(".main_menu ").css("color", "black");
          $(".child_menu_burger").css("-webkit-filter", "invert(0%) sepia(0%) saturate(3265%) hue-rotate(356deg) brightness(97%) contrast(103%)");
        });
        $("#shopify-section-header").mouseenter(function () {
          $(".header_main").removeClass("header_transparent");
          $(".header_main").removeClass("landing_header_transparent");
          $(".header_main").addClass("header_normal");
          $(".section-header").css("position", "fixed");
          $(".cls-1").css("stroke", "black");
          $(".cls-2").css("stroke", "black");
          $(".logo-svg").css("fill", "black");
          $(".customCartCounter").css("color", "black");
          $(".currency_switcher").css("color", "black");
          $(".main_menu ").css("color", "black");
        });
        // Mouse out of the header
        $("#shopify-section-header").mouseleave(function () {
          $(".header_main").addClass("header_transparent");
          $(".header_main").removeClass("header_normal");
          $(".section-header").css("position", "fixed");
          $(".cls-1").css("stroke", "white");
          $(".cls-2").css("stroke", "white");
          $(".logo-svg").css("fill", "white");
          $(".customCartCounter").css("color", "white");
          $(".main_menu").css("color", "white");
          $(".currency_switcher").css("color", "white");
        });
      } else {
        $("#shopify-section-header").unbind("mouseleave");
        $("#shopify-section-header").unbind("mouseenter");
      }
    }
  })

});

